<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">ارتباطات سازمانی</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label fw-bold">ارتباط</label>
          <input
              type="text"
              class="form-control"
              placeholder="ارتباط را وارد کنید"
              v-model="newItem.communication"
          />
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">نوع ارتباط</label>
          <select class="form-select" v-model="newItem.type">
            <option value="" disabled>نوع ارتباط را انتخاب کنید</option>
            <option :value="type" v-for="(type, index) in types" :key="index">
              {{ type }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Courses Table -->
      <GeneralTable
          :headers="['ارتباط', 'نوع ارتباط']"
          :fields="['communication', 'type']"
          :items="organizationalCommunications"
          :openEditModalMethod="openEditModal"
          @remove="removeCourse"
      />

      <!-- Edit Course Modal -->
      <GeneralModal
          v-show="editedItem"
          title="ویرایش ارتباط"
          modal-id="organizationModalId"
          @save="updateCourse"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">ارتباط</label>
            <input
                type="text"
                class="form-control"
                placeholder="ارتباط را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.communication"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">نوع ارتباط</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.type">
              <option value="" disabled>نوع ارتباط را انتخاب کنید</option>
              <option :value="type" v-for="(type, index) in types" :key="index">
                {{ type }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  communication: '',
  type: ''
}
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal },
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/organizational-communications/index',
      afterMutation: 'communicationDomain/setOrganizationalCommunications'
    });
  },
  data() {
    return {
      newItem: structuredClone(baseStructure),
      types: ['درون سازمانی', 'برون سازمانی'],
      editedItem: null,
      editIndex: null,
    };
  },
  computed: {
    organizationalCommunications: {
      get() {
        return this.$store.state.communicationDomain.organizationalCommunications;
      },
      set(value) {
        this.$store.commit("communicationDomain/setOrganizationalCommunications", value);
      }
    },
  },
  methods: {
    async addItem() {
      if (!this.newItem.communication || !this.newItem.type) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/organizational-communications/store',
      })

      this.organizationalCommunications = [...this.organizationalCommunications, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },
    removeCourse(index) {
      const course = this.organizationalCommunications.find((_, i) => i === index);
      this.organizationalCommunications = this.organizationalCommunications.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: course.id,
        endpoint: '/organizational-communications/delete',
      })
    },
    openEditModal(course, index) {
      this.editedItem = structuredClone(course);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('organizationModalId'));
      modal.show();
    },
    updateCourse() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedItem.communication || !this.editedItem.type) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      this.organizationalCommunications.splice(this.editIndex, 1, {...this.editedItem});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/organizational-communications/update',
      })

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('organizationModalId'));
      modal.hide();
    }
  }
};
</script>
